import {
  Companion_instance9tm2i64vxmrs as Companion_instance,
  PaymentMethod1x8gg38hdlghq as PaymentMethod,
  Bank3v98rc3cm50hg as Bank,
} from './paymentModels.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function preparePaymentMethodFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [PaymentMethod_id_getInstance(), PaymentMethod_name_getInstance(), PaymentMethod_bank_getInstance(), PaymentMethod_default_getInstance()];
  var tmp = Companion_instance.m2a();
  properties(tmp, (it) => props);
}
function PaymentMethod_id$name$delegate$lambda() {
  return Companion_instance.m2a().az().v11(0);
}
function PaymentMethod_id$_get_name_$ref_xwzkdc() {
  return (p0) => p0.k20();
}
function PaymentMethod_id$serializer$delegate$lambda() {
  var tmp = Companion_instance.m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PaymentMethod_id$_get_serializer_$ref_ax7q2h() {
  return (p0) => p0.j2j();
}
function PaymentMethod_id$annotations$delegate$lambda() {
  return Companion_instance.m2a().az().x11(0);
}
function PaymentMethod_id$_get_annotations_$ref_wnlw9h() {
  return (p0) => p0.bz();
}
var PaymentMethod_idClass;
function PaymentMethod_id() {
  if (PaymentMethod_idClass === VOID) {
    class $ {
      constructor() {
        PaymentMethod_id_instance = this;
        var tmp = this;
        tmp.f70_1 = lazy(PaymentMethod_id$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.g70_1 = lazy(PaymentMethod_id$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.h70_1 = lazy(PaymentMethod_id$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.f70_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PaymentMethod_id$_get_name_$ref_xwzkdc(), null);
        return tmp0.f2();
      }
      i70(receiver) {
        return receiver.j70_1;
      }
      m2j(receiver) {
        return this.i70(receiver instanceof PaymentMethod() ? receiver : THROW_CCE());
      }
      n70(receiver, value) {
        return receiver.o70(value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof PaymentMethod() ? receiver : THROW_CCE();
        return this.n70(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.g70_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PaymentMethod_id$_get_serializer_$ref_ax7q2h(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.h70_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PaymentMethod_id$_get_annotations_$ref_wnlw9h(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'PaymentMethod_id', VOID, VOID, [SerializableProperty()]);
    PaymentMethod_idClass = $;
  }
  return PaymentMethod_idClass;
}
var PaymentMethod_id_instance;
function PaymentMethod_id_getInstance() {
  if (PaymentMethod_id_instance === VOID)
    new (PaymentMethod_id())();
  return PaymentMethod_id_instance;
}
function PaymentMethod_name$name$delegate$lambda() {
  return Companion_instance.m2a().az().v11(1);
}
function PaymentMethod_name$_get_name_$ref_wbk7tc() {
  return (p0) => p0.k20();
}
function PaymentMethod_name$serializer$delegate$lambda() {
  var tmp = Companion_instance.m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PaymentMethod_name$_get_serializer_$ref_56w7nb() {
  return (p0) => p0.j2j();
}
function PaymentMethod_name$annotations$delegate$lambda() {
  return Companion_instance.m2a().az().x11(1);
}
function PaymentMethod_name$_get_annotations_$ref_yz7jmt() {
  return (p0) => p0.bz();
}
var PaymentMethod_nameClass;
function PaymentMethod_name() {
  if (PaymentMethod_nameClass === VOID) {
    class $ {
      constructor() {
        PaymentMethod_name_instance = this;
        var tmp = this;
        tmp.p70_1 = lazy(PaymentMethod_name$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.q70_1 = lazy(PaymentMethod_name$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.r70_1 = lazy(PaymentMethod_name$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.p70_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PaymentMethod_name$_get_name_$ref_wbk7tc(), null);
        return tmp0.f2();
      }
      i70(receiver) {
        return receiver.k70_1;
      }
      m2j(receiver) {
        return this.i70(receiver instanceof PaymentMethod() ? receiver : THROW_CCE());
      }
      s70(receiver, value) {
        return receiver.o70(VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof PaymentMethod() ? receiver : THROW_CCE();
        return this.s70(tmp, (value == null ? true : typeof value === 'string') ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.q70_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PaymentMethod_name$_get_serializer_$ref_56w7nb(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.r70_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PaymentMethod_name$_get_annotations_$ref_yz7jmt(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'PaymentMethod_name', VOID, VOID, [SerializableProperty()]);
    PaymentMethod_nameClass = $;
  }
  return PaymentMethod_nameClass;
}
var PaymentMethod_name_instance;
function PaymentMethod_name_getInstance() {
  if (PaymentMethod_name_instance === VOID)
    new (PaymentMethod_name())();
  return PaymentMethod_name_instance;
}
function PaymentMethod_bank$name$delegate$lambda() {
  return Companion_instance.m2a().az().v11(2);
}
function PaymentMethod_bank$_get_name_$ref_z2hrhd() {
  return (p0) => p0.k20();
}
function PaymentMethod_bank$serializer$delegate$lambda() {
  var tmp = Companion_instance.m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PaymentMethod_bank$_get_serializer_$ref_cb16wo() {
  return (p0) => p0.j2j();
}
function PaymentMethod_bank$annotations$delegate$lambda() {
  return Companion_instance.m2a().az().x11(2);
}
function PaymentMethod_bank$_get_annotations_$ref_a8rlqk() {
  return (p0) => p0.bz();
}
var PaymentMethod_bankClass;
function PaymentMethod_bank() {
  if (PaymentMethod_bankClass === VOID) {
    class $ {
      constructor() {
        PaymentMethod_bank_instance = this;
        var tmp = this;
        tmp.t70_1 = lazy(PaymentMethod_bank$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.u70_1 = lazy(PaymentMethod_bank$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.v70_1 = lazy(PaymentMethod_bank$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.t70_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PaymentMethod_bank$_get_name_$ref_z2hrhd(), null);
        return tmp0.f2();
      }
      i70(receiver) {
        return receiver.l70_1;
      }
      m2j(receiver) {
        return this.i70(receiver instanceof PaymentMethod() ? receiver : THROW_CCE());
      }
      w70(receiver, value) {
        return receiver.o70(VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof PaymentMethod() ? receiver : THROW_CCE();
        return this.w70(tmp, (value == null ? true : value instanceof Bank()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.u70_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PaymentMethod_bank$_get_serializer_$ref_cb16wo(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.v70_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PaymentMethod_bank$_get_annotations_$ref_a8rlqk(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'PaymentMethod_bank', VOID, VOID, [SerializableProperty()]);
    PaymentMethod_bankClass = $;
  }
  return PaymentMethod_bankClass;
}
var PaymentMethod_bank_instance;
function PaymentMethod_bank_getInstance() {
  if (PaymentMethod_bank_instance === VOID)
    new (PaymentMethod_bank())();
  return PaymentMethod_bank_instance;
}
function PaymentMethod_default$name$delegate$lambda() {
  return Companion_instance.m2a().az().v11(3);
}
function PaymentMethod_default$_get_name_$ref_mana22() {
  return (p0) => p0.k20();
}
function PaymentMethod_default$serializer$delegate$lambda() {
  var tmp = Companion_instance.m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[3];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PaymentMethod_default$_get_serializer_$ref_kf3h19() {
  return (p0) => p0.j2j();
}
function PaymentMethod_default$annotations$delegate$lambda() {
  return Companion_instance.m2a().az().x11(3);
}
function PaymentMethod_default$_get_annotations_$ref_9to8tb() {
  return (p0) => p0.bz();
}
var PaymentMethod_defaultClass;
function PaymentMethod_default() {
  if (PaymentMethod_defaultClass === VOID) {
    class $ {
      constructor() {
        PaymentMethod_default_instance = this;
        var tmp = this;
        tmp.x70_1 = lazy(PaymentMethod_default$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.y70_1 = lazy(PaymentMethod_default$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.z70_1 = lazy(PaymentMethod_default$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.x70_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PaymentMethod_default$_get_name_$ref_mana22(), null);
        return tmp0.f2();
      }
      i70(receiver) {
        return receiver.m70_1;
      }
      m2j(receiver) {
        return this.i70(receiver instanceof PaymentMethod() ? receiver : THROW_CCE());
      }
      a71(receiver, value) {
        return receiver.o70(VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof PaymentMethod() ? receiver : THROW_CCE();
        return this.a71(tmp, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.y70_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PaymentMethod_default$_get_serializer_$ref_kf3h19(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.z70_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PaymentMethod_default$_get_annotations_$ref_9to8tb(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'PaymentMethod_default', VOID, VOID, [SerializableProperty()]);
    PaymentMethod_defaultClass = $;
  }
  return PaymentMethod_defaultClass;
}
var PaymentMethod_default_instance;
function PaymentMethod_default_getInstance() {
  if (PaymentMethod_default_instance === VOID)
    new (PaymentMethod_default())();
  return PaymentMethod_default_instance;
}
//region block: exports
export {
  preparePaymentMethodFields as preparePaymentMethodFields3nobdwycnm1at,
};
//endregion

//# sourceMappingURL=PaymentMethodFields.mjs.map
